import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { MdCheck } from "react-icons/md";
import icon03_2 from "../../../screenassets/images/img/03_2.png";
import PaymentPage from "../../Payment/PaymentPage";
import { useSelector } from "react-redux";
import { selectMode } from '../../../service/slice/ThemeSlice';
import NoData from "../../NoData";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Loading from "../../Loading";


export default function PackageHistory() {

    DataTable.use(DT);
    const [loading, setLoading] = useState(true);
    const [packages, stePackages] = useState([]);
    const [subscription, steSubscription] = useState([]);
    const [displayRazorpay, setDisplayRazorpay] = useState(false);
    const [orderDetails, setOrderDetails] = useState({
        orderId: null,
        currency: null,
        amount: null
    });
    const usertoken = localStorage.getItem("authToken");
    const [swip, setSwip] = useState("1");
    const [grade, setGrade] = useState("6-8");
    const theme = useSelector(selectMode);
    const userSubscription = useSelector((state)=> state?.userSlice?.userSubscription)

    const themeColor = {
        color: theme === 'light' ? '#212529' : '#fff',
        background: theme === 'light' ? '#fff' : '#1c1c39',
        boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)'
    };


    function createPayment(packageId) {
        fetch(`${process.env.REACT_APP_API_URL}/service/placeOrder`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
            method: 'POST',
            body: JSON.stringify({
                packageId: packageId
            })
        }).then((response) => {
            return response.json();
        })
            .then((data) => {
                if (data && data?.order?.order_id) {
                    setOrderDetails({
                        orderId: data?.order?.order_id,
                        currency: data?.order?.currency,
                        amount: data?.order?.amount,
                    });
                    setDisplayRazorpay(true);
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // Fetch All Package 
    const fetchAllPackage = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllPackage`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.json();
    };

    // Fetch All Subscription
    const fetchAllSubscription = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user/getSubscriptionHistory`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    useEffect(() => {
        fetchAllPackage().then((res) => {
            if (res.status) {
                stePackages(res.packages);

                fetchAllSubscription().then((res) => {
                    if (res.status) {
                        setLoading(false);
                        steSubscription(res.subscriptionHistory);
                    } else {
                        toast.error("Failed to load subscription. Please try again.");
                    }

                }).catch((error) => {
                    toast.error("Unable to fetch package at the moment.");
                })

            } else {
                toast.error("Failed to load package. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch package at the moment.");
        });

    }, []);

    function handleSwip(val) {
        setSwip(val);
    }

    function handleGrade(val) {
        setGrade(val);
    }

    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?

                <Loading />
                :
                <>
                    <div className="col-md-12 col-12 mt-6">
                        <ul className="nav mt--20 nav-tabs pricing-button-one" id="myTab" role="tablist" style={themeColor}>
                            <li className="nav-item" role="presentation">
                                <button className={grade === "6-8" ? "active" : ""} id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" onClick={() => { handleGrade("6-8") }}>
                                    6-8
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={grade === "9-10" ? "active" : ""} id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleGrade("9-10") }}>
                                    9-10
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={grade === "11-12" ? "active" : ""} id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleGrade("11-12") }}>
                                    11-12
                                </button>
                            </li>

                        </ul>
                    </div>

                    <div className="col-md-12 col-12 mt-6">
                        <ul className="nav mt--20 nav-tabs pricing-button-one mt-4" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={swip === "1" ? "active" : ""} id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true" onClick={() => { handleSwip("1") }}>
                                    Monthly
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={swip === "2" ? "active" : ""} id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false" onClick={() => { handleSwip("2") }}>
                                    Yearly
                                </button>
                            </li>
                            <li className="right-image-inner">
                                <img src={icon03_2} alt="cta-wrapper" loading="lazy" />
                            </li>
                        </ul>
                    </div>

                    <div className="row mt-6">

                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-6">
                            <div className="pricing-style-one" style={themeColor}>
                                <div className="head">
                                    <span className="top">Free</span>
                                    <div className="date-use">
                                        <h4 className="title">Free</h4>
                                        <span>/month</span>
                                    </div>
                                </div>
                                <div className="body">
                                    {userSubscription ? <div className="rts-btn btn-border-p">Start Free Trial</div> : <Link to="#" className="rts-btn btn-border-p selected">Selected</Link>}
                                    <div className="chek-area">

                                        <div className="single-check">
                                            <MdCheck className="me-2" />
                                            <p className="mb-0">10,000 Monthly Word Limit</p>
                                        </div>

                                        <div className="single-check">
                                            <MdCheck className="me-2" />
                                            <p className="mb-0">10+ Templates</p>
                                        </div>

                                        <div className="single-check">
                                            <MdCheck className="me-2" />
                                            <p className="mb-0">All types of content</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {packages.map((pack, indx) => {
                            const description = JSON.parse(pack.description);

                            return pack.grade == grade && pack.type == swip ? <div key={indx} className="col-lg-4 col-md-6 col-sm-12 col-12 mt-6">
                                <div className="pricing-style-one" style={themeColor}>
                                    <div className="head">
                                        <span className="top">{pack.name}</span>
                                        <div className="date-use">
                                            <h4 className="title">{pack.amount}</h4>
                                            <span>/{pack.type === 2 ? "Yearly" : "Monthly"}</span>
                                        </div>
                                    </div>
                                    <div className="body">
                                        {userSubscription && (userSubscription?.package_id < pack.id)? <Link className="rts-btn btn-border-p notable" >Upgrade</Link> : userSubscription && (userSubscription?.package_id == pack.id) ? <Link className="rts-btn btn-border-p selected" >Selected</Link> : <Link className="rts-btn btn-border-p" onClick={() => { createPayment(pack.id) }}>Upgrade</Link>}

                                        {/* <div className="d-flex flex-wrap align-items-center mt-6" style={{ paddingLeft: "1.4em" }}> {pack.total_request} <h6 className="m-0 me-2 ms-2">Total Request</h6></div>

                                        <div className="d-flex flex-wrap align-items-center mb-2" style={{ paddingLeft: "1em" }}>
                                            <h6 className="m-0"> </h6>

                                            <p className="card-title ms-2 mt-0 mb-0 d-flex"><h5 className="m-0 me-2 ms-2">Level:</h5> {pack.grade} </p>

                                        </div> */}

                                        <div className="chek-area">
                                            {description.map((desc, id) => {
                                                return <div key={id} className="single-check">
                                                    <MdCheck className="me-2" />
                                                    <p className="mb-0">{desc}</p>
                                                </div>
                                            })}

                                        </div>
                                    </div>
                                </div>
                            </div>
                                :
                                null
                        })
                        }
                    </div>


                    <div className="container-xxl flex-grow-1 container-p-y my-5 px-3" style={{ height: "62vh" }}>
                        <div className="card shadow-sm border-0" style={themeColor}>
                            <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0">
                                <h5 className="card-title mb-0">Package History</h5>
                            </div>

                            {subscription.length > 0 ?
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <DataTable data={subscription.map((pack, index) =>
                                            [index + 1,
                                            pack.name,
                                            pack.amount,
                                            pack.type == "2" ? "Yearly" : "Monthly",
                                            pack.expire_on > Date.now() ?
                                                '<div class="text-success">Active</div>' :
                                                '<div class="text-danger">Inactive</div>',
                                            ])}

                                            className="display">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Type</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                        </DataTable>
                                    </div>
                                </div>
                                :
                                <NoData />
                            }

                        </div>
                    </div>
                </>
            }

            {displayRazorpay &&
                <PaymentPage
                    amount={orderDetails.amount}
                    currency={orderDetails.currency}
                    orderId={orderDetails.orderId}
                />

            }
        </>
    )
}
